import { Injectable, EventEmitter } from '@angular/core';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { BehaviorSubject } from 'rxjs';
import { MenuComponent } from './menu.component';

@Injectable()
export class MenuService {
    onItemEntered: EventEmitter<MenuItemComponent> = new EventEmitter();
    onMenuOpened: EventEmitter<MenuComponent> = new EventEmitter();
    menuItemClicked: EventEmitter<MenuItemComponent> = new EventEmitter();

    ngOnDestroy() {
        this.onItemEntered.complete();
        this.onMenuOpened.complete();
        this.menuItemClicked.complete();
    }
}
